"use client";
import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			preserveAspectRatio='xMidYMid slice'
			fill='none'
			width='168'
			id='shark'
			viewBox='0 0 178 178'>
			<mask
				id='mask0_220_564'
				style={{ maskType: "luminance" }}
				width='110'
				height='90'
				x='34'
				y='44'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M34.532 44.5h108.699v88.744H34.532V44.5z'></path>
			</mask>
			<g mask='url(#mask0_220_564)'>
				<path
					className={fillHover}
					d='M142.798 89.182c-9.944 8.371-16.643 11.41-16.643 11.41s-16.369-6.426-25.847-13.168c-.523-.373.215 3.612 7.912 10.749 3.758 3.485 7.62 6.378 10.453 9.754 1.22 1.46 2.001 3.201 2.264 4.219.392 1.511.989 4.057-.039 6.929-1.088 3.052-2.827 4.848-5.883 6.096-3.341 1.363-7.433.542-9.404-.515-1.856-.992-3.451-2.357-4.456-3.521-.176-.204-.33-.38-.469-.546.139 2.235.697 4.603 2.383 6.681 1.071 1.317 3.109 2.798 4.554 3.755l-15.731-.01c1.733-1.259 4.105-3.32 5.04-4.984 1.501-2.666 1.462-5.325 1.462-5.325s-3.816 5.279-10.116 5.279c-6.968 0-10.663-5.205-10.663-9.708 0-9.004 6.093-11.237 17.403-22.245 5.245-5.11 7.203-12.718 7.203-12.718s-24.77-.051-29.459 4.287c-.97-6.903 6.034-15.827 12.008-18.584.571-.265-.488 11.318-.488 11.318l13.326-14.77-.526 13.463 12.217-11.602-3.047 13.194s19.143-11.37 21.403-22.36c.263-1.286.527-1.441-.258-2.052-6.612-5.162-19.05-11.614-34.654-9.176-16.187 2.53-24.266 11.522-28.146 15.892 0 0-5.335-1.533-7.337-1.876C44.792 56.927 34 64.436 34.598 64.76c12.288 6.655 22.078 10.4 21.772 11.61-2.626 10.362-1.695 15.217-1.222 18.016-13.992 10.502-12.336 18.894-11.999 18.759 6.894-2.74 16.373-4.339 16.582-3.948 10.23 19.061 28.553 22.725 30.197 22.985a.515.515 0 00.186-.045c3.037.616 6.146.944 9.311.944 3.328 0 6.594-.358 9.787-1.038a.388.388 0 01.038.022s4.093-.829 7.465-2.34c3.384-1.515 6.392-5.737 8.211-11.405a45.493 45.493 0 011.361-3.69 43.65 43.65 0 012.642-5.286c1.242-2.121 2.384-4.409 4.259-6.019 9.738-8.353 10.098-14.553 9.606-14.143h.004zM86.65 50.22c6.545 2.978 13.526 4.806 13.526 4.806s-7.068.48-12.293 3.013c-.378.182-.545-.13-.803-.49-2.915-4.07-.699-7.451-.43-7.329z'></path>
			</g>
		</svg>
	);
}

export default Icon;
